export const DELETE_ENTITY_MAX_COUNT = 10;
